<mat-card class="card-base type-of-check">
    <mat-card-header>
        <mat-card-title class="card-title">
            Art und Umfang der Prüfung
            @if (permission.canEditCheckInfo()) {
                @if (!cardEditMode()) {
                    <button mat-icon-button (click)="enterCardEditMode()">
                        <mat-icon>edit</mat-icon>
                    </button>
                } @else {
                    <button mat-icon-button color="primary" (click)="saveCardEdit()" [disabled]="!canSaveEdit()">
                        <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button (click)="cancelCardEdit()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            }
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="card-content">
        <div>

            <!-- Erstellt von (immer read-only) -->
            <div class="check-info-table-row">
                <div>Erstellt von</div>
                <div class="check-info-entry">
                    <mat-chip>{{ data.checkInfoViewModel()?.creator?.displayName ?? '—' }}</mat-chip>
                </div>
            </div>


            <!-- Prüfer Kontrolle 1-1 -->
            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">
                <div class="check-info-label-with-icon">
                    Prüfer Kontrolle 1-1
                    <mat-icon class="info-tooltip-icon"
                        matTooltip="Führt die Eigenkontrolle (Kontrolle 1-1) durch.">
                        info_outline
                    </mat-icon>
                </div>
                <div class="check-info-entry">
                    @if (!cardEditMode()) {
                        <mat-chip>{{ data.checkInfoViewModel()?.checker11?.displayName ?? '�' }}</mat-chip>
                    } @else {
                        <mat-form-field>
                            <mat-label>Prüfer Kontrolle 1-1</mat-label>
                            <mat-select [value]="draftChecker11()"
                                disabled
                                (selectionChange)="draftChecker11.set($event.value)">
                                @for (user of data.users(); track user.oid) {
                                    <mat-option [value]="user.oid">{{ user.displayName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>

            <!-- Bezeichnung -->
            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">
                <div>Bezeichnung (FB / LP / Titel)</div>
                <div class="check-info-entry">
                    @if (!cardEditMode()) {
                        <mat-chip>{{ data.checkInfoViewModel()?.displayName ?? '�' }}</mat-chip>
                    } @else {
                        <mat-form-field>
                            <mat-label>Bezeichnung</mat-label>
                            <input matInput [value]="draftDisplayName()"
                                (input)="draftDisplayName.set($any($event.target).value)" />
                        </mat-form-field>
                    }
                </div>
            </div>

            <!-- Speicherort-Toggle (SharePoint vs Laufwerk P) -->
<!--            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">-->
<!--                <div>Speicherort</div>-->
<!--                <div class="check-info-entry">-->
<!--                    @if (!cardEditMode()) {-->
<!--                        @if (sharepointUrl()) {-->
<!--                            <mat-chip>-->
<!--                                <a [href]="sharepointUrl()" target="_blank" rel="noopener noreferrer" class="sharepoint-link">SharePoint – Link öffnen</a>-->
<!--                            </mat-chip>-->
<!--                        } @else if (data.checkInfoViewModel()?.directoryPFolderPath) {-->
<!--                            <mat-chip>-->
<!--                                <button-->
<!--                                    [cdkCopyToClipboard]="data.checkInfoViewModel()!.directoryPFolderPath"-->
<!--                                    (cdkCopyToClipboardCopied)="onPathCopied($event)"-->
<!--                                    class="copy-path-button">-->
<!--                                    <mat-icon>content_copy</mat-icon>-->
<!--                                    P:\ � Pfad kopieren-->
<!--                                </button>-->
<!--                            </mat-chip>-->
<!--                        } @else {-->
<!--                            <mat-chip>�</mat-chip>-->
<!--                        }-->
<!--                    } @else {-->
<!--                        @if (draftSourceType() === 'sharepoint') {-->
<!--                            <mat-form-field>-->
<!--                                <mat-label>Sharepoint-Pfad</mat-label>-->
<!--                                <input matInput [value]="draftSharepoint()"-->
<!--                                    (input)="draftSharepoint.set($any($event.target).value)" />-->
<!--                            </mat-form-field>-->
<!--                            @if (sharepointDraftError()) {-->
<!--                                <span class="url-error-hint">Bitte eine gültige URL eingeben (z. B. https://�)</span>-->
<!--                            }-->
<!--                        }-->
<!--                        @if (draftSourceType() === 'directoryP') {-->
<!--                            <mat-form-field>-->
<!--                                <mat-label>P:\-Pfad</mat-label>-->
<!--                                <input matInput [value]="draftDirectoryP()"-->
<!--                                    (input)="draftDirectoryP.set($any($event.target).value)" />-->
<!--                            </mat-form-field>-->
<!--                        }-->
<!--                    }-->
<!--                </div>-->
<!--            </div>-->

            <!-- Prüfer Kontrolle 1-2 -->
            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">
                <div class="check-info-label-with-icon">
                    Prüfer Kontrolle 1-2
                    <mat-icon class="info-tooltip-icon"
                        matTooltip="Vier-Augen-Prüfer: Führt die unabhängige Gegenprüfung (Kontrolle 1-2) durch.">
                        info_outline
                    </mat-icon>
                </div>
                <div class="check-info-entry">
                    @if (!cardEditMode()) {
                        <mat-chip [class.skipped-phase]="data.checkInfoViewModel()?.isConsultant">
                            {{ data.checkInfoViewModel()?.isConsultant ? 'Übersprungen (Gutachterl. Tätigkeit)' : (data.checkInfoViewModel()?.checker12?.displayName ?? '�') }}
                        </mat-chip>
                    } @else {
                        <mat-form-field>
                            <mat-label>Prüfer Kontrolle 1-2</mat-label>
                            <mat-select [value]="draftChecker12()"
                                [disabled]="permission.isPhase12Locked() || checker12Users().length === 0"
                                (selectionChange)="draftChecker12.set($event.value)">
                                @for (user of checker12Users(); track user.oid) {
                                    <mat-option [value]="user.oid">{{ user.displayName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>

            <!-- Prüffrist 1 -->
            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">
                <div>Prüffrist 1</div>
                <div class="check-info-entry">
                    @if (!cardEditMode()) {
                        <mat-chip>{{ (data.checkInfoViewModel()?.dueDate1 | date:'dd.MM.yyyy') ?? '—' }}</mat-chip>
                    } @else {
                        <mat-form-field>
                            <mat-label>Prüffrist 1</mat-label>
                            <input matInput [matDatepicker]="picker1"
                                [value]="draftDueDate1()"
                                [disabled]="permission.isPhase11Locked()"
                                (dateChange)="draftDueDate1.set($event.value)" required />
                            <mat-hint>TT.MM.JJJJ</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker1" />
                            <mat-datepicker #picker1 />
                        </mat-form-field>
                        @if (draftDueDate1Missing()) {
                            <span class="url-error-hint">Prüffrist 1 ist ein Pflichtfeld.</span>
                        }
                    }
                </div>
            </div>

            <!-- Prüfer Kontrolle 2 -->
            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">
                <div class="check-info-label-with-icon">
                    Prüfer Kontrolle 2
                    <mat-icon class="info-tooltip-icon"
                        matTooltip="Abschlusskontrolle: Führt die finale Prüfung (Kontrolle 2) durch.">
                        info_outline
                    </mat-icon>
                </div>
                <div class="check-info-entry">
                    @if (!cardEditMode()) {
                        <mat-chip>{{ data.checkInfoViewModel()?.checker2?.displayName ?? '�' }}</mat-chip>
                    } @else {
                        <mat-form-field>
                            <mat-label>Prüfer Kontrolle 2</mat-label>
                            <mat-select [value]="draftChecker2()"
                                [disabled]="permission.isPhase2Locked() || data.usersForChecker2().length === 0"
                                (selectionChange)="draftChecker2.set($event.value)">
                                @for (user of data.usersForChecker2(); track user.oid) {
                                    <mat-option [value]="user.oid">{{ user.displayName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                </div>
            </div>

            <!-- Prüffrist 2 -->
            <div class="check-info-table-row" [class.edit-mode]="cardEditMode()">
                <div>Prüffrist 2</div>
                <div class="check-info-entry">
                    @if (!cardEditMode()) {
                        <mat-chip>{{ (data.checkInfoViewModel()?.dueDate2 | date:'dd.MM.yyyy') ?? '�' }}</mat-chip>
                    } @else {
                        <mat-form-field>
                            <mat-label>Prüffrist 2</mat-label>
                            <input matInput [matDatepicker]="picker2"
                                [value]="draftDueDate2()"
                                [disabled]="permission.isPhase12Locked()"
                                (dateChange)="draftDueDate2.set($event.value)" />
                            <mat-hint>TT.MM.JJJJ</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker2" />
                            <mat-datepicker #picker2 />
                        </mat-form-field>
                        @if (draftDueDateError()) {
                            <span class="url-error-hint">Prüffrist 2 darf nicht vor Prüffrist 1 liegen.</span>
                        }
                    }
                </div>
            </div>

        </div>
    </mat-card-content>
</mat-card>

